import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import './Investment.css';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { colorMapping } from './config';
import loader from '../../../../assets/icons/loader.gif';

export default class DonutChart extends Component {
  state = {
    chartData: '',
  };

  componentDidMount() {
    var finalData = [];

    this.props.data.forEach((item) => {
      var obj = {
        x: item[0],
        y: item[1],
        name: item[2],
      };
      finalData.push(obj);
    });
    this.setState({
      chartData: finalData,
    });
  }

  render() {
    let chartData = this.props.data.length;
    const chart_config = {
      chart: {
        type: 'pie',
        height: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return 340;
          } else if (windowWidth < 375) {
            return 750;
          } else if (windowWidth >= 375 && windowWidth < 768) {
            return 750;
          }
        })(),
        margin: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return [30, 0, 0, 0];
          } else {
            return [20, 0, 0, 0];
          }
        })(),
        events: {
          load: () => {},
        },
      },
      title: {
        verticalAlign: 'top',
        useHTML: true,
        y: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return -70;
          } else {
            return -110;
          }
        })(),
      },
      subtitle: {
        text: '',
      },
      plotOptions: {
        pie: {
          colors: colorMapping(this.state.chartData),
          size: (function () {
            var windowWidth = window.innerWidth;
            if (windowWidth > 768) {
              return 250;
            } else {
              return 220;
            }
          })(),
          center: (function () {
            var windowWidth = window.innerWidth;
            if (windowWidth > 768) {
              return ['15%', '110px'];
            } else {
              return ['50%', '110px'];
            }
          })(),
          showInLegend: true,
        },
        series: {
          dataLabels: {
            enabled: false,
          },
          point: {
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
        },
      },
      legend: {
        itemStyle: {
          fontSize: '18px',
        },
        enabled: true,
        width: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth >= 320 && windowWidth <= 768) {
            return 370;
          } else if (windowWidth >= 768 && windowWidth <= 1023) {
            return 570;
          } else {
            // previously it is 370 revert
            return 570;
          }
        })(),
        itemWidth: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth < 768) {
            return 175;
          }
        })(),
        maxHeight: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return 300;
          } else {
            return 520;
          }
        })(),
        layout: 'horizontal',
        align: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return 'right';
          } else {
            return 'center';
          }
        })(),

        x: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return 40;
          } else if (windowWidth < 375) {
            return 50;
          } else if (windowWidth >= 375 && windowWidth < 768) {
            return 50;
          }
        })(),

        floating: true,
        verticalAlign: 'top',
        y: (function () {
          var windowWidth = window.innerWidth;
          if (windowWidth > 768) {
            return 10;
          } else {
            return 270;
          }
        })(),

        itemMarginTop: 10,
        useHTML: true,
        labelFormatter: function () {
          return (
            '<div>' +
            '<div id ="chartPercentageText">' +
            this.y.toFixed(2) +
            '%</div>' +
            '<div id="chartText">' +
            this.name +
            '</div>' +
            '<div id="chartText">' +
            '$' +
            parseFloat(this.x).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) +
            '</div>' +
            '</div>'
          );
        },
      },
      tooltip: {
        backgroundColor: '#006778',
        borderColor: '#006778',
        style: {
          color: '#ffffff',
          fontSize: '14px',
          fontFamily: 'HelveticaNeue, Helvetica, Arial, sans-serif',
          fontWeight: 'normal',
        },
        formatter: function () {
          return this.point.name + ': ' + this.y.toFixed(2) + '%';
        },
      },
      series: [
        {
          name: 'Delivered amount',
          innerSize: '60%',
          data: this.state.chartData,
        },
      ],
    };
    return (
      <div>
        {this.props.isAccountSummaryLoading === true ? (
          <div>
            <div className='loader-position-chart'>
              <div>
                <img src={loader} className='mr-icon' alt='loader' data-test='pre-loader' />
              </div>
            </div>
          </div>
        ) : this.props.data.length !== 0 ? (
          <div>
            <div id='chartHeight' data-test='investment-chart-fa'>
              <HighchartsReact highcharts={Highcharts} options={chart_config} />
            </div>
          </div>
        ) : this.props.errorMessage !== '' ? (
          <div className='noDataPlacement-chart-error' data-test='error-message'>
            <div>{this.props.errorMessage}</div>
          </div>
        ) : (
          <div className='noDataPlacement-chart'>
            <div className=''>
              <div>
                <img src={loader} alt='loader' />
                <div className='no-data-text' data-test='no-data-wrap'>No data found.</div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
DonutChart.propTypes = {
  chartNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
  errorMessage: PropTypes.string,
};
